export const ACCEPT_AGREEMENT_START = 'ACCEPT_AGREEMENT_START';
export const ACCEPT_AGREEMENT_SUCCESS = 'ACCEPT_AGREEMENT_SUCCESS';
export const ACCEPT_AGREEMENT_ERROR = 'ACCEPT_AGREEMENT_ERROR';
export const REJECT_AGREEMENT_START = 'REJECT_AGREEMENT_START';
export const REJECT_AGREEMENT_SUCCESS = 'REJECT_AGREEMENT_SUCCESS';
export const REJECT_AGREEMENT_ERROR = 'REJECT_AGREEMENT_ERROR';
export const NEW_AGREEMENT_DATA_RECEIVED = 'NEW_AGREEMENT_DATA_RECEIVED';



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/agreementActionTypes.js